import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router';
import { lazyInject } from '@intelingu/core/IoC/container';
import { UserStore } from '@intelingu/core/stores/UserStore';
import { AccountRemoved } from './pages/session/AccountRemoved';
import { ChangePasswordPage } from './pages/session/ChangePasswordPage';
import { LoginPage } from './pages/session/LoginPage';
import { OAuthPage } from './pages/session/OAuthPage';
import { RegisterPage } from './pages/session/RegisterPage';
import { ResetConfirmPage } from './pages/session/ResetConfirmPage';
import { ResetPage } from './pages/session/ResetPage';
import { Footer } from './partials/Footer';
import { GuestHeader } from './partials/GuestHeader';
import {StepRegisterPage} from "./pages/session/StepRegisterPage";
import {SubscribeRedirectPage} from "./pages/session/SubscribeRedirectPage";

export interface SessionLayoutProps extends RouteComponentProps<any> {
}

@observer export class SessionLayout extends Component<SessionLayoutProps, any> {

    @lazyInject(UserStore) userStore: UserStore;

    render() {
        const { match } = this.props;

        if (this.userStore.user) {
            // return <Redirect to={`/`} />
        }

        return <div className={'profile-layout'}>
            <GuestHeader {...this.props} />

            <Switch>
                <Route path={`${match.path}/oauth/:provider/:app?`} component={OAuthPage} />
                <Route path={`${match.path}/login`} component={LoginPage} />
                <Route path={`${match.path}/forward`} component={SubscribeRedirectPage} />
                <Route path={`${match.path}/reset`} component={ResetPage} />
                <Route path={`${match.path}/reset_confirm`} component={ResetConfirmPage} />
                <Route path={`${match.path}/change`} component={ChangePasswordPage} />
                <Route path={`${match.path}/register`} component={RegisterPage} />
                <Route path={`${match.path}/removed`} component={AccountRemoved} />
            </Switch>

            <Footer />
        </div>
    }

}
